// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Cy1lr","logo":"styles_logo__kogz2","content":"styles_content__lU6wr"};
module.exports.__checksum = "c0d4b17924ed"